@if (tour.active() && tour.step(); as step) {
  <div class="to-root" data-testid="tour-overlay">
    <!-- The cutout IS the backdrop: a huge spread shadow dims everything
         outside the spotlight, so no SVG mask or four-panel scrim is needed.
         With no anchor there's no rect, and .to-veil dims the whole screen. -->
    @if (spot(); as r) {
      <div
        class="to-spot"
        [class.is-circle]="step.shape === 'circle'"
        [style.top.px]="r.top"
        [style.left.px]="r.left"
        [style.width.px]="r.width"
        [style.height.px]="r.height"
        aria-hidden="true"
      ></div>
    } @else {
      <div class="to-veil" aria-hidden="true"></div>
    }

    <!-- Blocks every tap outside the card: the tour drives navigation itself, so
         letting a stray tap through mid-step would desync the spotlight. -->
    <div class="to-catch" (click)="$event.stopPropagation()" aria-hidden="true"></div>

    <div
      class="to-card"
      [class.is-centred]="!spot()"
      [style.top.px]="cardTop()"
      [style.bottom.px]="cardBottom()"
      role="dialog"
      aria-modal="true"
      aria-live="polite"
      [attr.aria-label]="step.title"
      data-testid="tour-card"
    >
      <p class="to-count">{{ tour.index() + 1 }} of {{ tour.total() }}</p>
      <h2 class="to-title">{{ step.title }}</h2>
      <p class="to-text">{{ step.text }}</p>

      <div class="to-actions">
        <button
          type="button"
          class="to-skip"
          (click)="tour.skip()"
          data-testid="tour-skip"
        >
          {{ Cta.Skip }}
        </button>
        <div class="to-actions-end">
          @if (tour.index() > 0) {
            <button
              type="button"
              class="to-back"
              (click)="tour.back()"
              data-testid="tour-back"
            >
              {{ Cta.Back }}
            </button>
          }
          <button
            #nextBtn
            type="button"
            class="to-next"
            (click)="tour.next()"
            data-testid="tour-next"
          >
            {{ tour.isLast() ? Cta.Done : Cta.Next }}
          </button>
        </div>
      </div>
    </div>
  </div>
}
